<template>
  <div class="insurance-company-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Insurance Company Section -->
    <section class="company-section">
      <div class="container">
        <div class="company-content">
          <PageTitle title="Insurance Company" />
          
          <div class="company-grid">
            <button 
              v-for="company in insuranceCompanies" 
              :key="company.id"
              :class="['company-button', { 'selected': selectedCompany === company.id }]"
              @click="selectCompany(company.name)"
            >
              {{ company.name }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'InsuranceCompanyPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedCompany: null,
      userQuoteData: null,
      insuranceCompanies: [
        { id: 'aaa', name: 'AAA INSURANCE CO' },
        { id: 'allstate', name: 'ALLSTATE INSURANCE' },
        { id: 'farm-bureau', name: 'FARM BUREAU/FARM FAMILY/RURAL' },
        { id: 'farmers', name: 'FARMERS INSURANCE' },
        { id: 'geico', name: 'GEICO' },
        { id: 'hart', name: 'HART ACCIDENT AND INDEMNITY' },
        { id: 'nationwide', name: 'NATIONWIDE GENERAL INSURANCE' },
        { id: 'progressive', name: 'PROGRESSIVE' },
        { id: 'safeco', name: 'SAFECO' },
        { id: 'state-farm', name: 'STATE FARM COUNTY MUTUAL' },
        { id: 'usaa', name: 'USAA' },
        { id: 'other', name: 'OTHER' }
      ]
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 加载之前选择的保险公司（如果有的话）
          if (this.userQuoteData.former_insurer) {
            this.selectedCompany = this.userQuoteData.former_insurer
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectCompany(companyId) {
      this.selectedCompany = companyId
      
      // 更新用户数据
      this.userQuoteData.former_insurer = companyId
      this.saveUserData()
      
      console.log('Selected insurance company:', companyId)
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('insurancecompany')
      // 跳转到性别选择页面
      this.$router.push('/gender')
    },
    
    goBack() {
      this.$router.push('/insurance')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.insurance-company-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Company Section */
.company-section {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.company-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.company-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.company-button {
  padding: 1rem 1.5rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.company-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.company-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .company-content {
    padding: 0 1rem;
  }

  .company-grid {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }

  .company-button {
    padding: 1rem;
    font-size: 0.9rem;
    min-height: 55px;
  }

  .company-section {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {
  .company-grid {
    gap: 0.6rem;
  }

  .company-button {
    padding: 0.9rem;
    font-size: 0.85rem;
    min-height: 50px;
  }

  .company-section {
    padding: 1rem 0;
  }
}
</style>
